module.exports = __webpack_public_path__ + "static/media/AAVE.84a4d333.png";